/**
 * Created by piotr.pozniak@thebeaverhead.com on 06/04/2019.
 */

import axios from "axios";
import AxiosConfig from "../AxiosConfig";
import triggerTagEvent from "../helpers/tagmanager";
import { getReferralCoupon } from "./plans";

export const getReferralId = () => {
  return (
    (window.Rewardful && window.Rewardful.referral) ||
    "checkout_" + new Date().getTime()
  );
};

/**
 * @deprecated
 * @returns {function(*): Promise<AxiosResponse<any> | never>}
 */ /*
export function initiateSubscription(
  stripeObject,
  cardElement,
  billingData,
  planUUID,
  isYearly,
  coupon = null,
  referralCoupon = null,
  selectedPlan = null
) {
  return function (dispatch) {
    dispatch({ type: "SUBSCRIPTION_INITIATE" });

    return stripeObject
      .createToken(cardElement)
      .then((response) => {
        let axiosPromise = null;
        let hasCoupon = false;

        if (response.error && response.error.code) {
          throw response;
        }
        if (coupon && coupon.trim().length) {
          const url = "/api/coupons/apply.json";
          hasCoupon = true;
          axiosPromise = axios.post(
            url,
            {
              code: coupon,
              stripe_token: response.token.id,
              referral: getReferralId(),
              billing_data: {
                ...billingData,
                billing_contact: billingData.name,
              },
              subscription_plan_uuid: planUUID,
              is_annual: isYearly ? 1 : 0,
            },
            AxiosConfig.getAuthConfig()
          );
        } else {
          const url = "/api/subscriptions/" + planUUID + ".json";

          axiosPromise = axios.post(
            url,
            {
              stripe_token: response.token.id,
              is_yearly: isYearly ? 1 : 0,
              billing_data: billingData,
              referral: getReferralId(),
              referralCoupon: referralCoupon ? referralCoupon.id : null,
            },
            AxiosConfig.getAuthConfig()
          );
        }

        return axiosPromise
          .then((response) => {
            dispatch({
              type: "SUBSCRIPTION_INITIATE_FULFILLED",
              payload: response.data,
            });

            if (selectedPlan) {
              const GAData = {
                transaction_id: response.data.transaction_id,
                item_id: planUUID,
                account_id: response.data.organization_uuid,
                coupon: hasCoupon ? coupon.trim() : null,
                is_yearly: isYearly ? true : false,
                referral: getReferralId(),
                referralCoupon: referralCoupon ? referralCoupon.id : null,
                code: selectedPlan.code,
                name: selectedPlan.name,
                price: Number.parseFloat(
                  isYearly ? selectedPlan.price_annual : selectedPlan.price
                ),
                isBranded: selectedPlan.is_branded ? true : false,
              };

              triggerTagEvent("purchase", GAData);
            }
          })
          .catch(function (error) {
            dispatch({
              type: "SUBSCRIPTION_INITIATE_REJECTED",
              payload: error,
            });
          });
      })
      .catch((response) => {
        console.log(response);
        dispatch({
          type: "SUBSCRIPTION_INITIATE_REJECTED",
          payload: response.error,
        });
      });
  };
}
*/
export function createStripeSession(stripePriceId) {
  return function (dispatch) {
    dispatch({ type: "SUBSCRIPTION_CHECKOUT_SESSION_CREATE" });

    let axiosPromise = null;

    const url = "/api/subscriptions/create_session.json";

    axiosPromise = axios.post(
      url,
      {
        stripe_price_id: stripePriceId,
        referral: getReferralId(),
        referralCoupon: getReferralCoupon()?.id,
      },
      AxiosConfig.getAuthConfig()
    );

    return axiosPromise
      .then((response) => {
        dispatch({
          type: "SUBSCRIPTION_CHECKOUT_SESSION_CREATE_FULFILLED",
          payload: response.data,
        });

        // TODO G4A
        // if (selectedPlan) {
        //   const GAData = {
        //     transaction_id: response.data.transaction_id,
        //     item_id: planUUID,
        //     account_id: response.data.organization_uuid,
        //     coupon: hasCoupon ? coupon.trim() : null,
        //     is_yearly: isYearly ? true : false,
        //     referral: getReferralId(),
        //     referralCoupon: referralCoupon ? referralCoupon.id : null,
        //     code: selectedPlan.code,
        //     name: selectedPlan.name,
        //     price: Number.parseFloat(
        //       isYearly ? selectedPlan.price_annual : selectedPlan.price
        //     ),
        //     isBranded: selectedPlan.is_branded ? true : false,
        //   };
        //
        //   triggerTagEvent("purchase", GAData);
        // }
      })
      .catch(function (error) {
        dispatch({
          type: "SUBSCRIPTION_CHECKOUT_SESSION_CREATE_REJECTED",
          payload: error,
        });
      });
  };
}

export function fetchCustomerPortalLink(flow) {
  return function (dispatch) {
    dispatch({ type: "SUBSCRIPTION_CUSTOMER_PORTAL_LINK_FETCH" });

    let axiosPromise = null;
    let url = "/api/subscriptions/create_customer_portal_link.json";

    if (flow) {
      url += "?" + AxiosConfig.objectToURLQuery({ flow });
    }
    axiosPromise = axios.get(url, AxiosConfig.getAuthConfig());

    return axiosPromise
      .then((response) => {
        dispatch({
          type: "SUBSCRIPTION_CUSTOMER_PORTAL_LINK_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "SUBSCRIPTION_CUSTOMER_PORTAL_LINK_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}
export function createPaymentLink(stripePriceId) {
  return function (dispatch) {
    dispatch({ type: "SUBSCRIPTION_PAYMENT_LINK_FETCH" });

    let axiosPromise = null;

    let url = "/api/subscriptions/create_payment_link.json";

    const coupon = getReferralCoupon();
    let data = {
      stripe_price_id: stripePriceId,
      referral: getReferralId(),
      referralCoupon: getReferralCoupon()?.id,
    };

    axiosPromise = axios.post(url, data, AxiosConfig.getAuthConfig());

    return axiosPromise
      .then((response) => {
        dispatch({
          type: "SUBSCRIPTION_PAYMENT_LINK_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "SUBSCRIPTION_PAYMENT_LINK_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}
export function fetchCustomerSession(stripePriceId) {
  return function (dispatch) {
    dispatch({ type: "SUBSCRIPTION_CUSTOMER_SESSION_FETCH" });

    let axiosPromise = null;
    let data = {
      stripe_price_id: stripePriceId,
      referral: getReferralId(),
      referralCoupon: getReferralCoupon()?.id,
    };
    let url = "/api/subscriptions/create_customer_session.json";

    axiosPromise = axios.post(url, data, AxiosConfig.getAuthConfig());

    return axiosPromise
      .then((response) => {
        dispatch({
          type: "SUBSCRIPTION_CUSTOMER_SESSION_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "SUBSCRIPTION_CUSTOMER_SESSION_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}
